import { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from './JournalOverview';

export default function ProfileMenu({ anchor, collapsed, items, onClose, name }) {
  const panel = useRef(null), close = useRef(onClose);
  close.current = onClose;
  const [position, setPosition] = useState({ left: 8, top: 8 });
  useLayoutEffect(() => {
    const trigger = anchor.current;
    const place = () => {
      const rect = trigger.getBoundingClientRect(), height = panel.current?.offsetHeight || 320;
      setPosition({ left: Math.max(8, Math.min(collapsed ? rect.right + 16 : rect.left, window.innerWidth - 260)), top: Math.max(8, Math.min(collapsed ? rect.top : rect.bottom + 8, window.innerHeight - height - 8)) });
    };
    place(); panel.current?.querySelector('[role="menuitem"]')?.focus();
    const outside = e => { if (!panel.current?.contains(e.target) && !trigger.contains(e.target)) close.current(); };
    const key = e => { if (e.key === 'Escape') { e.preventDefault(); close.current(); } };
    document.addEventListener('pointerdown', outside); document.addEventListener('keydown', key);
    window.addEventListener('resize', place); window.addEventListener('scroll', place, true);
    return () => {
      document.removeEventListener('pointerdown', outside); document.removeEventListener('keydown', key);
      window.removeEventListener('resize', place); window.removeEventListener('scroll', place, true);
      if (trigger.isConnected) trigger.focus();
    };
  }, [anchor, collapsed]);
  const navigate = event => {
    const buttons = [...panel.current.querySelectorAll('[role="menuitem"]')], current = buttons.indexOf(document.activeElement);
    let next;
    if (event.key === 'ArrowDown') next = (current + 1) % buttons.length;
    if (event.key === 'ArrowUp') next = (current + buttons.length - 1) % buttons.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = buttons.length - 1;
    if (event.key === 'Tab') { event.preventDefault(); onClose(); return; }
    if (next != null) { event.preventDefault(); buttons[next].focus(); }
  };
  return createPortal(<div ref={panel} id="desktop-profile-menu" className="tl-profile-menu" style={position} onKeyDown={navigate}>
    <div className="tl-profile-menu-heading"><span className="tl-eyebrow">YOUR WORKSPACE</span><strong>{name || 'Trader'}</strong></div>
    <div role="menu" aria-label="Profile and settings">{items.filter(Boolean).map(({ label, icon, action, danger }) => <button role="menuitem" key={label} className={danger ? 'is-danger' : ''} onClick={() => { onClose(); action?.(); }}><Icon name={icon} size={17}/><span>{label}</span></button>)}</div>
  </div>, document.body);
}
